import { render } from "./facility-account-list.vue?vue&type=template&id=44a0f094"
import script from "./facility-account-list.vue?vue&type=script&lang=js"
export * from "./facility-account-list.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__